import type { WebSocketMessageData } from '@/types/ws/WebSocketMessageData.ts';
import { useWebSocketStore } from '@/stores/WebSocketStore.ts';
import { useSessionStore } from '@/stores/SessionStore.ts';
import { z } from 'zod';
import { syncStoresToWebViewAction } from '@/actions/sync/SyncStoresToWebViewAction.ts';

const ConnectedClientsDataSchema = z.object({
    clients: z.array(
        z.object({
            id: z.string().uuid(),
            isDesktopApp: z.boolean(),
        }),
    ),
});

export const connectedClientsMessageHandler = (messageData: WebSocketMessageData) => {
    const data = ConnectedClientsDataSchema.parse(messageData);

    const webSocketStore = useWebSocketStore();
    webSocketStore.connectedClients = data.clients;

    const sessionStore = useSessionStore();
    if (!sessionStore.isInsideWebView) {
        syncStoresToWebViewAction();
    }
};
